import { ApiBase } from '../apiBase';
import { ApiHexaBase } from './ApiHexaBase';
import { HexaCustomDop } from './models/CustomDopModels';

export class ApiCustomDop extends ApiHexaBase {
  public static customDopBaseUrl(): string {
    return `${ApiHexaBase.baseUrl}/custom_dops`;
  }

  public static async index(params: {
    page?: number;
    size?: number;
    search?: string;
  }) {
    const response = await ApiBase.get(this.customDopBaseUrl(), params);

    return response.data.data as {
      total: number;
      custom_dop: HexaCustomDop[];
    };
  }

  public static async index_files(id: string, file_name: string, date: string) {
    const response = await ApiBase.get(
      `${this.customDopBaseUrl()}/${id}/files`,
      {
        file_name,
        date,
      }
    );
    return response.data.data as {
      total: number;
      files: Partial<HexaCustomDop>[];
    };
  }

  public static async show(id: number | string) {
    const response = await ApiBase.get(`${this.customDopBaseUrl()}/${id}`);
    return response.data.data as HexaCustomDop;
  }

  public static async createOrUpdate(id: string, data: Partial<HexaCustomDop>) {
    const response = await ApiBase.post(
      `${this.customDopBaseUrl()}/${id}`,
      data
    );
    return response.data.data as HexaCustomDop;
  }
}
